import React from "react";

export default function About() {
  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-10 py-24">
      <p className="eyebrow mb-3">About Sanctum</p>
      <h1 className="font-display text-5xl md:text-6xl tracking-tight font-light leading-tight">
        A quiet place for songs that matter.
      </h1>
      <div className="mt-10 space-y-6 text-neutral-700 leading-relaxed">
        <p>
          Sanctum is a distraction-free marketplace for Christian music. We built it because we wanted
          a place where the art comes first — where the room around the song is quiet enough to listen.
        </p>
        <p>
          Every song has a 30-second preview so you know exactly what you are buying. MP3 tracks are
          $1.99. MP4 videos are $2.99. No subscriptions, no bundles, no small print. Payments run on
          Stripe. Files are delivered the moment your payment clears.
        </p>
        <p>
          Thank you for being here. May these songs meet you where you are.
        </p>
      </div>
    </div>
  );
}
